import { c as _c } from "react/compiler-runtime";
import { AccommodationCard, AccommodationCardSkeleton } from "@website/accommodation-ui/accommodation-card";
import { HotelCitiesMainContentPropertiesType } from "@website/accommodation-ui/hotel-cities-main-content";
import { ListingContainerPropertiesType } from "@website/accommodation-ui/listing-container";
import { useFetcher, useFetchers } from "@website/fetcher/use-fetcher";
import { useLoginStatus } from "@website/hooks/auth-manager";
import { Button } from "@website/ui/button";
import { useSnackbar } from "@website/ui/snackbar";
import { getOrigin } from "@website/utils/channel/get-origin";
import { isInvalidCheckin, today, tomorrow } from "@website/utils/date-format";
import { ExperimentSDK } from "@website/utils/experiments/client";
import { isFilled } from "@website/utils/is-filled";
import { MapFilterProperties, useCityFilterState, useFilters } from "@website/widget/filter";
import { HeaderPropertiesType } from "@website/widget/header";
import { TelesalesAppName } from "@website/widget/telesales";
import isEmpty from "lodash-es/isEmpty";
import last from "lodash-es/last";
import omit from "lodash-es/omit";
import orderBy from "lodash-es/orderBy";
import pick from "lodash-es/pick";
import toNumber from "lodash-es/toNumber";
import toString from "lodash-es/toString";
import uniq from "lodash-es/uniq";
import { useRouter } from "next/router";
import { useEffect, useRef, useState } from "react";
import { useVillagesFilter } from "./filter.hook";
import { VILLA_LIST_PAGE_SIZE, fetchHotelRateData, fetchHotelReviewData, fetchInstalmentWallet, fetchVillagesData, transformHotelSchema, transformVillaListingSchema } from "./index.server";
import { handleEventMapSearchClicked, handleVillaAccommodationCardTrackingEvents, handleVillaCityPageVisited } from "./index.tracking";
import { CityPagePropertiesType, HotelCityContentItemType, VillaListingCardType, VillaLocationResponseType, reasonsSchema } from "./index.types";
import { useVillaSearch } from "./search.hook";
export const getBannersByType = (data, type: string) => data?.find?.(item => item?.type === type)?.data?.sort?.((a, b) => a?.order - b?.order) || null || [];
export const useCityPage = properties => {
  const $ = _c(240);
  const {
    locationData,
    villagesData,
    hasError,
    smallBanners,
    staticBanners
  } = properties;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [1];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [pages, setPages] = useState(t0);
  const router = useRouter();
  const [updatedModal, setUpdatedModal] = useState(false);
  const timerReference = useRef(null);
  const t1 = properties?.seoData?.pageTitle;
  let t2;
  if ($[1] !== locationData || $[2] !== t1) {
    t2 = {
      locationData,
      seoPageTitle: t1
    };
    $[1] = locationData;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const searchProperties = useVillaSearch(t2);
  const {
    onOpenFilters
  } = useCityFilterState();
  const {
    isLoggedIn
  } = useLoginStatus();
  const selectedHotelId = router.query?.selectedHotelId;
  const {
    enqueue,
    dequeue
  } = useSnackbar();
  const isCompleteInfoDismissed = useRef(false);
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = ["instalmentWallet"];
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== isLoggedIn) {
    t4 = {
      enabled: isLoggedIn,
      retry: false,
      queryKey: t3,
      queryFn: _temp
    };
    $[5] = isLoggedIn;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const {
    data: instalmentWallet,
    isLoading: isInstallmentWalletLoading,
    isFetching: isInstallmentWalletFetching
  } = useFetcher(t4);
  let t5;
  if ($[7] !== pages || $[8] !== router.query) {
    let t6;
    if ($[10] !== router.query) {
      t6 = page => ({
        queryKey: ["villagesData", omit(router.query, ["modal", "selectedHotelId", "popover", "item", "filters_visible"]), page],
        queryFn: () => fetchVillagesData({
          ...router.query,
          page
        })
      });
      $[10] = router.query;
      $[11] = t6;
    } else {
      t6 = $[11];
    }
    t5 = pages.map(t6);
    $[7] = pages;
    $[8] = router.query;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[12] !== t5) {
    t6 = {
      queries: t5
    };
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  const freshVillagesData = useFetchers(t6);
  let t7;
  if ($[14] !== freshVillagesData) {
    t7 = () => Promise.any(freshVillagesData.map(_temp2)).finally(() => setUpdatedModal(false));
    $[14] = freshVillagesData;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  const updateResultSearchHandler = t7;
  let t8;
  if ($[16] !== router) {
    t8 = value => router.push({
      pathname: router.pathname,
      query: {
        ...router.query,
        order_by: value
      }
    }, undefined, {
      shallow: true,
      scroll: false
    });
    $[16] = router;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  const onSortChange = t8;
  let t10;
  let t9;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = () => {
      timerReference.current = setTimeout(() => setUpdatedModal(true), 900000);
      return () => {
        timerReference.current && clearTimeout(timerReference.current);
      };
    };
    t10 = [];
    $[18] = t10;
    $[19] = t9;
  } else {
    t10 = $[18];
    t9 = $[19];
  }
  useEffect(t9, t10);
  let t11;
  if ($[20] !== router) {
    t11 = () => {
      if (!router.isReady) {
        return;
      }
      const {
        date_from,
        date_to
      } = router.query;
      const shouldRedirect = isInvalidCheckin(date_from, date_to);
      if (shouldRedirect) {
        router.replace({
          pathname: "/[locationType]/[cityTitle]",
          query: {
            locationType: router.query.locationType,
            cityTitle: router.query.cityTitle
          }
        }, undefined, {
          shallow: true,
          scroll: false
        });
      }
    };
    $[20] = router;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== router.isReady || $[23] !== router.query) {
    t12 = [router.isReady, router.query];
    $[22] = router.isReady;
    $[23] = router.query;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  useEffect(t11, t12);
  let t13;
  if ($[25] !== freshVillagesData) {
    t13 = !freshVillagesData?.length || freshVillagesData?.some(_temp3);
    $[25] = freshVillagesData;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  const loading = t13;
  const villageResponses = freshVillagesData?.flatMap(_temp4) || [];
  let t14;
  if ($[27] !== router.query) {
    t14 = isEmpty(omit(router.query, ["locationType", "cityTitle"]));
    $[27] = router.query;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  const hasOnlyLocationQuery = t14;
  let t15;
  if ($[29] !== hasOnlyLocationQuery) {
    t15 = hasOnlyLocationQuery || ExperimentSDK.isOn("new-villa-plp");
    $[29] = hasOnlyLocationQuery;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  const isNewPlP = t15;
  const activeVillageResponses = hasOnlyLocationQuery && villageResponses.length === 0 ? villagesData ? [villagesData] : [] : villageResponses;
  const filteredVillages = activeVillageResponses.flatMap(_temp5);
  let t16;
  if ($[31] !== router.query) {
    t16 = response => ((response?.data || []) as Array<VillaLocationResponseType>).map(item => ({
      ...transformHotelSchema(item, router.query),
      count: toNumber(response.count || 0),
      total: toNumber(response.total || 0),
      page: toNumber(response.current_page || 1)
    }));
    $[31] = router.query;
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  const hotelCitiesMainContentList = activeVillageResponses.flatMap(t16);
  let t17;
  if ($[33] !== router.query.date_from || $[34] !== router.query.date_to || $[35] !== router.query.room_capacity) {
    t17 = (item_0, index) => transformVillaListingSchema(item_0, index, {
      ...(router.query?.date_from ? {
        date_from: toString(router.query.date_from)
      } : {}),
      ...(router.query?.date_to ? {
        date_to: toString(router.query.date_to)
      } : {}),
      ...(toNumber(router.query?.room_capacity) > 0 ? {
        room_capacity: toNumber(router.query.room_capacity)
      } : {})
    });
    $[33] = router.query.date_from;
    $[34] = router.query.date_to;
    $[35] = router.query.room_capacity;
    $[36] = t17;
  } else {
    t17 = $[36];
  }
  const transformedVillages = filteredVillages.map(t17);
  const totalVillagesCount = last(activeVillageResponses)?.total || 0;
  const citiesFilterProperties = useVillagesFilter(totalVillagesCount, freshVillagesData?.[0]?.isFetched, locationData?.title, isNewPlP);
  let t18;
  if ($[37] !== citiesFilterProperties.filtersSchema) {
    t18 = {
      schema: citiesFilterProperties.filtersSchema
    };
    $[37] = citiesFilterProperties.filtersSchema;
    $[38] = t18;
  } else {
    t18 = $[38];
  }
  const {
    selectedFiltersCount
  } = useFilters(t18);
  const hasSelectedFilters = selectedFiltersCount !== 0;
  let t19;
  if ($[39] !== hasSelectedFilters || $[40] !== locationData?.title || $[41] !== router.query.locationType) {
    t19 = hasSelectedFilters ? <>متاسفانه در حال حاضر هتل و اقامتگاهی متناسب با فیلتر های انتخابی شما در این بازه تاریخی وجود ندارد .</> : router.query.locationType === "category" ? <>متاسفانه در حال حاضر اقامتگاهی متناسب با دسته‌بندی انتخابی شما یافت نشد.</> : <>متاسفانه هتل و اقامتگاه فعالی در این بازه تاریخی در شهر{" "}<span className="text-on-surface-high-emphasis font-medium">"{locationData?.title}"</span>{" "}یافت نشد. لطفا شهرهای دیگر را جستجو کنید.</>;
    $[39] = hasSelectedFilters;
    $[40] = locationData?.title;
    $[41] = router.query.locationType;
    $[42] = t19;
  } else {
    t19 = $[42];
  }
  const listingEmptyStateCaption = t19;
  let t20;
  if ($[43] !== citiesFilterProperties || $[44] !== hasSelectedFilters || $[45] !== searchProperties) {
    t20 = () => {
      if (hasSelectedFilters) {
        citiesFilterProperties.clearAllFilters();
        return;
      }
      searchProperties.setIsSearchPanelOpen(true);
    };
    $[43] = citiesFilterProperties;
    $[44] = hasSelectedFilters;
    $[45] = searchProperties;
    $[46] = t20;
  } else {
    t20 = $[46];
  }
  const handleListingEmptyStateAction = t20;
  const filteredPages = orderBy(uniq(activeVillageResponses.map(_temp6).filter(Boolean)));
  const [cityPageVisitFirstVilla] = transformedVillages;
  const cityPageVisitCity = cityPageVisitFirstVilla?.cityTitle || "";
  const cityPageVisitCityId = cityPageVisitFirstVilla?.cityId || 0;
  const cityPageVisitAvailableHotelIds = filteredVillages.filter(_temp7).map(_temp8).filter(Boolean).join(",");
  const cityPageVisitPage = last(filteredPages) || 0;
  let t21;
  if ($[47] !== router.query.date_from) {
    t21 = toString(router.query.date_from);
    $[47] = router.query.date_from;
    $[48] = t21;
  } else {
    t21 = $[48];
  }
  const cityPageVisitDateFrom = t21;
  let t22;
  if ($[49] !== router.query.date_to) {
    t22 = toString(router.query.date_to);
    $[49] = router.query.date_to;
    $[50] = t22;
  } else {
    t22 = $[50];
  }
  const cityPageVisitDateTo = t22;
  let t23;
  if ($[51] !== cityPageVisitAvailableHotelIds || $[52] !== cityPageVisitCity || $[53] !== cityPageVisitCityId || $[54] !== cityPageVisitDateFrom || $[55] !== cityPageVisitDateTo || $[56] !== cityPageVisitPage) {
    t23 = [cityPageVisitCity, cityPageVisitCityId, cityPageVisitDateFrom, cityPageVisitDateTo, cityPageVisitAvailableHotelIds, cityPageVisitPage];
    $[51] = cityPageVisitAvailableHotelIds;
    $[52] = cityPageVisitCity;
    $[53] = cityPageVisitCityId;
    $[54] = cityPageVisitDateFrom;
    $[55] = cityPageVisitDateTo;
    $[56] = cityPageVisitPage;
    $[57] = t23;
  } else {
    t23 = $[57];
  }
  const cityPageVisitTrackingKey = t23.join("|");
  const lastCityPageVisitTrackingKey = useRef(null);
  let t24;
  let t25;
  if ($[58] !== cityPageVisitAvailableHotelIds || $[59] !== cityPageVisitCity || $[60] !== cityPageVisitCityId || $[61] !== cityPageVisitDateFrom || $[62] !== cityPageVisitDateTo || $[63] !== cityPageVisitPage || $[64] !== cityPageVisitTrackingKey || $[65] !== isNewPlP || $[66] !== loading) {
    t24 = () => {
      if (!isNewPlP || loading || !cityPageVisitCityId || lastCityPageVisitTrackingKey.current === cityPageVisitTrackingKey) {
        return;
      }
      lastCityPageVisitTrackingKey.current = cityPageVisitTrackingKey;
      handleVillaCityPageVisited({
        city: cityPageVisitCity,
        city_id: cityPageVisitCityId,
        date_from: new Date(cityPageVisitDateFrom),
        date_to: new Date(cityPageVisitDateTo),
        available_hotels_id: cityPageVisitAvailableHotelIds.split(",").filter(Boolean).map(Number),
        page: cityPageVisitPage,
        last_minute_loaded: 0,
        count_of_last_minute_cards: 0,
        blue_box_loaded: 0,
        count_of_blue_box_cards: 0
      });
    };
    t25 = [cityPageVisitAvailableHotelIds, cityPageVisitCity, cityPageVisitCityId, cityPageVisitDateFrom, cityPageVisitDateTo, cityPageVisitPage, cityPageVisitTrackingKey, isNewPlP, loading];
    $[58] = cityPageVisitAvailableHotelIds;
    $[59] = cityPageVisitCity;
    $[60] = cityPageVisitCityId;
    $[61] = cityPageVisitDateFrom;
    $[62] = cityPageVisitDateTo;
    $[63] = cityPageVisitPage;
    $[64] = cityPageVisitTrackingKey;
    $[65] = isNewPlP;
    $[66] = loading;
    $[67] = t24;
    $[68] = t25;
  } else {
    t24 = $[67];
    t25 = $[68];
  }
  useEffect(t24, t25);
  let t26;
  if ($[69] !== locationData?.location) {
    t26 = locationData?.location || {};
    $[69] = locationData?.location;
    $[70] = t26;
  } else {
    t26 = $[70];
  }
  const {
    latitude,
    longitude
  } = t26;
  const coordinate = latitude && longitude ? `${latitude},${longitude},11,33` : null;
  let t27;
  if ($[71] !== coordinate || $[72] !== locationData?.id || $[73] !== locationData?.title || $[74] !== router) {
    const goToMapFilter = () => {
      handleEventMapSearchClicked({
        city: locationData?.title,
        city_id: locationData?.id,
        date_from: toString(router.query?.date_from),
        date_to: toString(router.query?.date_to)
      });
      return router.push({
        pathname: "/map",
        query: {
          ...(coordinate ? {
            coordinate
          } : {}),
          ...omit(router.query, ["locationType", "cityTitle", "viewport_change_type"])
        }
      });
    };
    t27 = {
      label: "\u0645\u0634\u0627\u0647\u062F\u0647 \u0631\u0648\u06CC \u0646\u0642\u0634\u0647",
      onClick: goToMapFilter
    };
    $[71] = coordinate;
    $[72] = locationData?.id;
    $[73] = locationData?.title;
    $[74] = router;
    $[75] = t27;
  } else {
    t27 = $[75];
  }
  const mapFilterProperties = t27;
  const t28 = Boolean(selectedHotelId);
  let t29;
  if ($[76] !== selectedHotelId) {
    t29 = ["hotelRateData", selectedHotelId];
    $[76] = selectedHotelId;
    $[77] = t29;
  } else {
    t29 = $[77];
  }
  let t30;
  if ($[78] !== t28 || $[79] !== t29) {
    t30 = {
      refetchOnMount: true,
      enabled: t28,
      queryKey: t29,
      queryFn: _temp9
    };
    $[78] = t28;
    $[79] = t29;
    $[80] = t30;
  } else {
    t30 = $[80];
  }
  const {
    data: hotelRateData
  } = useFetcher(t30);
  const t31 = Boolean(selectedHotelId);
  let t32;
  if ($[81] !== selectedHotelId) {
    t32 = ["hotelReviewData", selectedHotelId];
    $[81] = selectedHotelId;
    $[82] = t32;
  } else {
    t32 = $[82];
  }
  let t33;
  if ($[83] !== t31 || $[84] !== t32) {
    t33 = {
      refetchOnMount: true,
      enabled: t31,
      queryKey: t32,
      queryFn: _temp10
    };
    $[83] = t31;
    $[84] = t32;
    $[85] = t33;
  } else {
    t33 = $[85];
  }
  const {
    data: hotelReviewData
  } = useFetcher(t33);
  let t34;
  if ($[86] !== coordinate || $[87] !== router) {
    t34 = () => router?.push({
      pathname: "/map",
      query: {
        ...(coordinate ? {
          coordinate
        } : {}),
        ...omit(router?.query, ["cityTitle", "locationType", "extra_capacity", "modal", "coordinate", "viewport_change_type"])
      }
    }, undefined, {
      shallow: true,
      scroll: false
    });
    $[86] = coordinate;
    $[87] = router;
    $[88] = t34;
  } else {
    t34 = $[88];
  }
  const onMapClick = t34;
  let t35;
  if ($[89] !== dequeue || $[90] !== enqueue || $[91] !== router.query || $[92] !== searchProperties.setIsSearchPanelOpen) {
    t35 = () => {
      if (["date_from", "date_to"].every(key => !isFilled(router.query[key]))) {
        if (isCompleteInfoDismissed.current) {
          return;
        }
        const buttonProperties = {
          onClick: () => {
            searchProperties.setIsSearchPanelOpen.bind(null, true)();
            setTimeout(() => {
              dequeue(snackBarId);
            }, 100);
          },
          color: "secondary" as const,
          variant: "text" as const
        };
        const snackBarId = enqueue("\u0628\u0631\u0627\u06CC \u0645\u0634\u0627\u0647\u062F\u0647 \u0642\u06CC\u0645\u062A \u062F\u0642\u06CC\u0642 \u0627\u0642\u0627\u0645\u062A\u06AF\u0627\u0647\u200C\u0647\u0627\u066C \u062A\u0627\u0631\u06CC\u062E \u0631\u0627 \u0648\u0627\u0631\u062F \u06A9\u0646\u06CC\u062F.", "default", "one-line", <Button {...buttonProperties}>تکمیل اطلاعات</Button>);
        isCompleteInfoDismissed.current = true;
      }
    };
    $[89] = dequeue;
    $[90] = enqueue;
    $[91] = router.query;
    $[92] = searchProperties.setIsSearchPanelOpen;
    $[93] = t35;
  } else {
    t35 = $[93];
  }
  let t36;
  if ($[94] !== dequeue || $[95] !== enqueue || $[96] !== router || $[97] !== searchProperties.setIsSearchPanelOpen) {
    t36 = [router, searchProperties.setIsSearchPanelOpen, enqueue, dequeue];
    $[94] = dequeue;
    $[95] = enqueue;
    $[96] = router;
    $[97] = searchProperties.setIsSearchPanelOpen;
    $[98] = t36;
  } else {
    t36 = $[98];
  }
  useEffect(t35, t36);
  let t37;
  if ($[99] === Symbol.for("react.memo_cache_sentinel")) {
    t37 = {
      title: "\u0627\u0642\u0627\u0645\u062A\u06AF\u0627\u0647"
    };
    $[99] = t37;
  } else {
    t37 = $[99];
  }
  const t38 = coordinate && mapFilterProperties;
  let t39;
  if ($[100] !== citiesFilterProperties || $[101] !== loading || $[102] !== t38) {
    t39 = {
      ...citiesFilterProperties,
      mapFilterProps: t38,
      loading
    };
    $[100] = citiesFilterProperties;
    $[101] = loading;
    $[102] = t38;
    $[103] = t39;
  } else {
    t39 = $[103];
  }
  let t40;
  if ($[104] !== updateResultSearchHandler || $[105] !== updatedModal) {
    t40 = {
      isOpen: updatedModal,
      onUpdateResult: updateResultSearchHandler
    };
    $[104] = updateResultSearchHandler;
    $[105] = updatedModal;
    $[106] = t40;
  } else {
    t40 = $[106];
  }
  const t41 = hasOnlyLocationQuery ? VILLA_LIST_PAGE_SIZE : 0;
  let t42;
  if ($[107] !== staticBanners) {
    t42 = getBannersByType(staticBanners, "static");
    $[107] = staticBanners;
    $[108] = t42;
  } else {
    t42 = $[108];
  }
  let t43;
  if ($[109] !== t42) {
    t43 = {
      slide: t42
    };
    $[109] = t42;
    $[110] = t43;
  } else {
    t43 = $[110];
  }
  const t44 = hasSelectedFilters ? "\u062D\u0630\u0641 \u0641\u06CC\u0644\u062A\u0631\u0647\u0627" : "\u062A\u063A\u06CC\u06CC\u0631 \u0645\u0642\u0635\u062F";
  const t45 = hasSelectedFilters ? "filters-not-found" : "not-found";
  let t46;
  if ($[111] !== handleListingEmptyStateAction || $[112] !== listingEmptyStateCaption || $[113] !== t44 || $[114] !== t45) {
    t46 = {
      actionTitle: t44,
      caption: listingEmptyStateCaption,
      onActionClick: handleListingEmptyStateAction,
      variant: t45
    };
    $[111] = handleListingEmptyStateAction;
    $[112] = listingEmptyStateCaption;
    $[113] = t44;
    $[114] = t45;
    $[115] = t46;
  } else {
    t46 = $[115];
  }
  let t47;
  if ($[116] !== router.query) {
    t47 = item_2 => <AccommodationCard {...item_2} handleTrackingEvents={trackingData => handleVillaAccommodationCardTrackingEvents({
      ...item_2,
      ...trackingData
    }, router.query)} />;
    $[116] = router.query;
    $[117] = t47;
  } else {
    t47 = $[117];
  }
  let t48;
  if ($[118] !== loading || $[119] !== t41 || $[120] !== t43 || $[121] !== t46 || $[122] !== t47 || $[123] !== transformedVillages) {
    t48 = {
      list: transformedVillages,
      isLoading: loading,
      animationStartIndex: t41,
      renderSkeleton: _temp11,
      getKey: _temp12,
      banners: t43,
      emptyState: t46,
      renderCard: t47
    };
    $[118] = loading;
    $[119] = t41;
    $[120] = t43;
    $[121] = t46;
    $[122] = t47;
    $[123] = transformedVillages;
    $[124] = t48;
  } else {
    t48 = $[124];
  }
  const t49 = t48 satisfies ListingContainerPropertiesType<VillaListingCardType>;
  const t50 = citiesFilterProperties.chipsFiltersSchema;
  const t51 = citiesFilterProperties.clearAllFilters;
  const t52 = citiesFilterProperties?.isFilterFetching;
  const t53 = locationData?.title;
  const t54 = router.query.locationType !== "category";
  const t55 = citiesFilterProperties?.hasNearby;
  const t56 = citiesFilterProperties.showStripLoadingSkeleton;
  const t57 = !hasOnlyLocationQuery;
  let t58;
  if ($[125] !== router.query.order_by) {
    t58 = toString(router.query.order_by);
    $[125] = router.query.order_by;
    $[126] = t58;
  } else {
    t58 = $[126];
  }
  let t59;
  if ($[127] === Symbol.for("react.memo_cache_sentinel")) {
    t59 = [{
      label: "\u0627\u0631\u0632\u0627\u0646\u062A\u0631\u06CC\u0646",
      value: "asc"
    }, {
      label: "\u06AF\u0631\u0627\u0646\u062A\u0631\u06CC\u0646",
      value: "desc"
    }];
    $[127] = t59;
  } else {
    t59 = $[127];
  }
  let t60;
  if ($[128] !== isNewPlP || $[129] !== onSortChange || $[130] !== t58) {
    t60 = {
      isNewPlP,
      onChange: onSortChange,
      initialValue: t58,
      list: t59
    };
    $[128] = isNewPlP;
    $[129] = onSortChange;
    $[130] = t58;
    $[131] = t60;
  } else {
    t60 = $[131];
  }
  let t61;
  if ($[132] !== citiesFilterProperties.chipsFiltersSchema || $[133] !== citiesFilterProperties.clearAllFilters || $[134] !== citiesFilterProperties.showStripLoadingSkeleton || $[135] !== isNewPlP || $[136] !== loading || $[137] !== onOpenFilters || $[138] !== selectedFiltersCount || $[139] !== t52 || $[140] !== t53 || $[141] !== t54 || $[142] !== t55 || $[143] !== t57 || $[144] !== t60 || $[145] !== totalVillagesCount) {
    t61 = {
      chipsFiltersSchema: t50,
      clearAllFilters: t51,
      loading,
      isFilterFetching: t52,
      setFilterOpen: onOpenFilters,
      city: t53,
      totalItem: totalVillagesCount,
      hasCityPrefix: t54,
      hasCityNearby: t55,
      selectedFiltersCount,
      showStripLoadingSkeleton: t56,
      shouldAnimateStripItems: t57,
      isNewPlP,
      sortProperties: t60
    };
    $[132] = citiesFilterProperties.chipsFiltersSchema;
    $[133] = citiesFilterProperties.clearAllFilters;
    $[134] = citiesFilterProperties.showStripLoadingSkeleton;
    $[135] = isNewPlP;
    $[136] = loading;
    $[137] = onOpenFilters;
    $[138] = selectedFiltersCount;
    $[139] = t52;
    $[140] = t53;
    $[141] = t54;
    $[142] = t55;
    $[143] = t57;
    $[144] = t60;
    $[145] = totalVillagesCount;
    $[146] = t61;
  } else {
    t61 = $[146];
  }
  let t62;
  if ($[147] !== filteredPages || $[148] !== loading || $[149] !== totalVillagesCount) {
    t62 = {
      pages: filteredPages,
      setPages,
      loading,
      totalCount: totalVillagesCount,
      pageSize: VILLA_LIST_PAGE_SIZE
    };
    $[147] = filteredPages;
    $[148] = loading;
    $[149] = totalVillagesCount;
    $[150] = t62;
  } else {
    t62 = $[150];
  }
  const t63 = locationData?.title;
  const t64 = citiesFilterProperties.clearAllFilters;
  const t65 = citiesFilterProperties?.hasNearby;
  const t66 = Number(selectedHotelId);
  let t67;
  if ($[151] !== hotelCitiesMainContentList) {
    t67 = hotelCitiesMainContentList || [];
    $[151] = hotelCitiesMainContentList;
    $[152] = t67;
  } else {
    t67 = $[152];
  }
  let t68;
  if ($[153] !== hotelReviewData?.rateReviews) {
    t68 = hotelReviewData?.rateReviews?.map(_temp13)?.splice(0, 5);
    $[153] = hotelReviewData?.rateReviews;
    $[154] = t68;
  } else {
    t68 = $[154];
  }
  let t69;
  if ($[155] !== hotelRateData || $[156] !== t68) {
    t69 = {
      rate: hotelRateData,
      comments: t68
    };
    $[155] = hotelRateData;
    $[156] = t68;
    $[157] = t69;
  } else {
    t69 = $[157];
  }
  const t70 = t69 as unknown as HotelCitiesMainContentPropertiesType["reviewData"];
  let t71;
  if ($[158] === Symbol.for("react.memo_cache_sentinel")) {
    t71 = [];
    $[158] = t71;
  } else {
    t71 = $[158];
  }
  const t72 = searchProperties.setIsSearchPanelOpen;
  let t73;
  if ($[159] !== staticBanners) {
    t73 = getBannersByType(staticBanners, "static");
    $[159] = staticBanners;
    $[160] = t73;
  } else {
    t73 = $[160];
  }
  const t74 = instalmentWallet?.isEligible;
  const t75 = instalmentWallet?.showDownPayment;
  const t76 = instalmentWallet?.markup;
  const t77 = isInstallmentWalletLoading || isInstallmentWalletFetching;
  let t78;
  if ($[161] !== t74 || $[162] !== t75 || $[163] !== t76 || $[164] !== t77) {
    t78 = {
      isEligible: t74,
      showDownPayment: t75,
      markup: t76,
      isLoading: t77
    };
    $[161] = t74;
    $[162] = t75;
    $[163] = t76;
    $[164] = t77;
    $[165] = t78;
  } else {
    t78 = $[165];
  }
  let t79;
  if ($[166] !== citiesFilterProperties.clearAllFilters || $[167] !== hasError || $[168] !== hasSelectedFilters || $[169] !== isNewPlP || $[170] !== loading || $[171] !== searchProperties.setIsSearchPanelOpen || $[172] !== t63 || $[173] !== t65 || $[174] !== t66 || $[175] !== t67 || $[176] !== t70 || $[177] !== t73 || $[178] !== t78 || $[179] !== totalVillagesCount) {
    t79 = {
      size: "small" as const,
      cityTitle: t63,
      clearAllFilters: t64,
      hasError,
      hasFilters: hasSelectedFilters,
      hasCityNearby: t65,
      selectedHotelId: t66,
      hotelList: t67,
      reviewData: t70,
      hotelsSuggested: t71,
      loading,
      setIsSearchPanelOpen: t72,
      bannerSlideList: t73,
      totalItem: totalVillagesCount,
      snappPayData: t78,
      isNewPlP
    };
    $[166] = citiesFilterProperties.clearAllFilters;
    $[167] = hasError;
    $[168] = hasSelectedFilters;
    $[169] = isNewPlP;
    $[170] = loading;
    $[171] = searchProperties.setIsSearchPanelOpen;
    $[172] = t63;
    $[173] = t65;
    $[174] = t66;
    $[175] = t67;
    $[176] = t70;
    $[177] = t73;
    $[178] = t78;
    $[179] = totalVillagesCount;
    $[180] = t79;
  } else {
    t79 = $[180];
  }
  let t80;
  if ($[181] === Symbol.for("react.memo_cache_sentinel")) {
    t80 = getOrigin();
    $[181] = t80;
  } else {
    t80 = $[181];
  }
  let t81;
  if ($[182] !== isNewPlP) {
    t81 = {
      title: "\u0648\u06CC\u0644\u0627 \u0648 \u0627\u0642\u0627\u0645\u062A\u06AF\u0627\u0647",
      href: `${t80}/villa`,
      ...(isNewPlP ? {
        className: "!text-xs !leading-4"
      } : {})
    };
    $[182] = isNewPlP;
    $[183] = t81;
  } else {
    t81 = $[183];
  }
  let t82;
  if ($[184] !== isNewPlP || $[185] !== locationData?.state?.slug || $[186] !== locationData?.state?.title || $[187] !== router.query) {
    t82 = locationData?.state?.slug ? [{
      title: `ویلاهای استان ${locationData?.state?.title}`,
      ...(isNewPlP ? {
        className: "!text-xs !leading-4"
      } : {}),
      href: {
        pathname: "/[locationType]/[cityTitle]",
        query: {
          ...pick(router.query, ["cityTitle", "locationType"]),
          locationType: "state",
          cityTitle: locationData?.state?.slug
        }
      }
    }] : [];
    $[184] = isNewPlP;
    $[185] = locationData?.state?.slug;
    $[186] = locationData?.state?.title;
    $[187] = router.query;
    $[188] = t82;
  } else {
    t82 = $[188];
  }
  const t83 = router.query.locationType === "category" ? locationData?.title : ` ویلاهای ${locationData?.title}`;
  let t84;
  if ($[189] !== isNewPlP) {
    t84 = isNewPlP ? {
      className: "!text-xs !leading-4"
    } : {};
    $[189] = isNewPlP;
    $[190] = t84;
  } else {
    t84 = $[190];
  }
  let t85;
  if ($[191] !== router.query) {
    t85 = pick(router.query, ["cityTitle", "locationType"]);
    $[191] = router.query;
    $[192] = t85;
  } else {
    t85 = $[192];
  }
  let t86;
  if ($[193] !== t85) {
    t86 = {
      pathname: "/[locationType]/[cityTitle]",
      query: t85
    };
    $[193] = t85;
    $[194] = t86;
  } else {
    t86 = $[194];
  }
  let t87;
  if ($[195] !== t83 || $[196] !== t84 || $[197] !== t86) {
    t87 = {
      title: t83,
      ...t84,
      href: t86
    };
    $[195] = t83;
    $[196] = t84;
    $[197] = t86;
    $[198] = t87;
  } else {
    t87 = $[198];
  }
  let t88;
  if ($[199] !== t81 || $[200] !== t82 || $[201] !== t87) {
    t88 = {
      color: "default" as const,
      variant: "default" as const,
      list: [t81, ...t82, t87]
    };
    $[199] = t81;
    $[200] = t82;
    $[201] = t87;
    $[202] = t88;
  } else {
    t88 = $[202];
  }
  let t89;
  if ($[203] !== router.query.date_from) {
    t89 = router?.query?.date_from || today();
    $[203] = router.query.date_from;
    $[204] = t89;
  } else {
    t89 = $[204];
  }
  let t90;
  if ($[205] !== t89) {
    t90 = toString(t89);
    $[205] = t89;
    $[206] = t90;
  } else {
    t90 = $[206];
  }
  let t91;
  if ($[207] !== router.query.date_to) {
    t91 = router?.query?.date_to || tomorrow();
    $[207] = router.query.date_to;
    $[208] = t91;
  } else {
    t91 = $[208];
  }
  let t92;
  if ($[209] !== t91) {
    t92 = toString(t91);
    $[209] = t91;
    $[210] = t92;
  } else {
    t92 = $[210];
  }
  const t93 = router?.query?.cityTitle;
  let t94;
  if ($[211] !== t93) {
    t94 = toString(t93);
    $[211] = t93;
    $[212] = t94;
  } else {
    t94 = $[212];
  }
  let t95;
  if ($[213] !== t90 || $[214] !== t92 || $[215] !== t94) {
    t95 = {
      app: "villa" as TelesalesAppName,
      checkin: t90,
      checkout: t92,
      city_from: "",
      city_to: t94,
      funnel: "telesales_box"
    };
    $[213] = t90;
    $[214] = t92;
    $[215] = t94;
    $[216] = t95;
  } else {
    t95 = $[216];
  }
  const t96 = !isNewPlP;
  const t97 = isNewPlP ? "scroll" as const : undefined;
  let t98;
  if ($[217] !== isNewPlP || $[218] !== t95 || $[219] !== t96 || $[220] !== t97) {
    t98 = {
      description: " \u0628\u0639\u062F \u0627\u0632 \u062B\u0628\u062A \u062F\u0631\u062E\u0648\u0627\u0633\u062A\u060C \u06A9\u0627\u0631\u0634\u0646\u0627\u0633\u0627\u0646 \u0645\u0627 \u062F\u0631 \u0627\u0633\u0631\u0639 \u0648\u0642\u062A \u0628\u0627 \u0634\u0645\u0627 \u062A\u0645\u0627\u0633 \u062E\u0648\u0627\u0647\u0646\u062F \u06AF\u0631\u0641\u062A \u0648 \u0634\u0645\u0627 \u0631\u0627 \u0628\u0631\u0627\u06CC \u0631\u0632\u0631\u0648 \u0648\u06CC\u0644\u0627 \u0631\u0627\u0647\u0646\u0645\u0627\u06CC\u06CC \u062E\u0648\u0627\u0647\u0646\u062F \u06A9\u0631\u062F.",
      reasons: reasonsSchema,
      requestData: t95,
      storageKey: "villa_submit-tele-sale-reserve",
      className: "!left-6 !right-auto",
      showAnimatedMobileButton: t96,
      mobileButtonAnimation: t97,
      isNewPlP
    };
    $[217] = isNewPlP;
    $[218] = t95;
    $[219] = t96;
    $[220] = t97;
    $[221] = t98;
  } else {
    t98 = $[221];
  }
  let t99;
  if ($[222] !== smallBanners) {
    t99 = getBannersByType(smallBanners, "small");
    $[222] = smallBanners;
    $[223] = t99;
  } else {
    t99 = $[223];
  }
  let t100;
  if ($[224] !== t99) {
    t100 = {
      bannerSlideList: t99
    };
    $[224] = t99;
    $[225] = t100;
  } else {
    t100 = $[225];
  }
  const t101 = Boolean(coordinate);
  let t102;
  if ($[226] !== isNewPlP || $[227] !== onMapClick || $[228] !== searchProperties || $[229] !== t100 || $[230] !== t101 || $[231] !== t39 || $[232] !== t40 || $[233] !== t49 || $[234] !== t61 || $[235] !== t62 || $[236] !== t79 || $[237] !== t88 || $[238] !== t98) {
    t102 = {
      headerProps: t37 as HeaderPropertiesType,
      searchProperties,
      citiesFilterProperties: t39,
      modalProps: t40,
      listingContainerProps: t49,
      hotelListHeaderProps: t61,
      hotelPaginationProps: t62,
      hotelCitiesMainContentProps: t79,
      hotelBreadcrumbsProperties: t88,
      telesaleProperties: t98,
      bannersProperties: t100,
      onMapClick,
      hasMap: t101,
      isNewPlP
    };
    $[226] = isNewPlP;
    $[227] = onMapClick;
    $[228] = searchProperties;
    $[229] = t100;
    $[230] = t101;
    $[231] = t39;
    $[232] = t40;
    $[233] = t49;
    $[234] = t61;
    $[235] = t62;
    $[236] = t79;
    $[237] = t88;
    $[238] = t98;
    $[239] = t102;
  } else {
    t102 = $[239];
  }
  return t102;
};
function _temp() {
  return fetchInstalmentWallet();
}
function _temp2(t0) {
  const {
    refetch
  } = t0;
  return refetch();
}
function _temp3(t0) {
  const {
    isFetching,
    status
  } = t0;
  return isFetching || status === "pending";
}
function _temp4(t0) {
  const {
    data
  } = t0;
  return data ? [data] : [];
}
function _temp5(t0) {
  const {
    data: data_0
  } = t0;
  return (data_0 || []) as Array<VillaLocationResponseType>;
}
function _temp6(t0) {
  const {
    current_page
  } = t0;
  return current_page;
}
function _temp7(t0) {
  const {
    room_data
  } = t0;
  return room_data?.is_active;
}
function _temp8(t0) {
  const {
    room_data: room_data_0
  } = t0;
  return room_data_0.id;
}
function _temp9(t0) {
  const {
    queryKey
  } = t0;
  return fetchHotelRateData(queryKey[1]);
}
function _temp10(t0) {
  const {
    queryKey: queryKey_0
  } = t0;
  return fetchHotelReviewData(queryKey_0[1], 1, "villa", {} as Record<string, string>);
}
function _temp11() {
  return <AccommodationCardSkeleton />;
}
function _temp12(item_1) {
  return item_1.id;
}
function _temp13(comment) {
  return comment;
}